import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Expense, ICustomProduct, Product } from 'shared/types';
import { round } from 'shared/utility';

export function QuoteDetailUpdateTotal() {
  const { setValue } = useFormContext();
  const watchProducts: Product[] = useWatch({ name: 'products' });
  const watchExpenses: Expense[] = useWatch({ name: 'expenses' });
  const watchCustomProducts: ICustomProduct[] = useWatch({ name: 'customProducts' });

  useEffect(() => {
    const newProductTotal = (watchProducts || []).reduce((total, product) => {
      total += product.extendedPrice;
      return total;
    }, 0);

    const customProductsTotal = (watchCustomProducts || []).reduce<number>((total, customProduct) => {
      total += Number(customProduct.customProductPrice) * Number(customProduct.customProductQuantity);
      return total;
    }, 0);

    const expenseTotal = (watchExpenses || []).reduce((total, expense) => {
      total += expense.extendedPrice;
      return total;
    }, 0);

    const finalTotal = round(newProductTotal + customProductsTotal + expenseTotal);

    setValue('quoteTotal', finalTotal);
  }, [watchProducts, watchExpenses, watchCustomProducts, setValue]);
  return null;
}
